import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProofSection() {
  return <section className="py-20 bg-gradient-to-b from-[#0a0e1a] to-[#05070d]" data-id="element-240">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-241">
        <FadeIn data-id="element-242">
          <div className="mb-8" data-id="element-243">
            <span className="text-7xl md:text-9xl font-extrabold text-transparent bg-clip-text bg-gradient-to-b from-[#00d9ff] to-[#00d9ff]/20" data-id="element-244">
              87%
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold mb-6 leading-tight" data-id="element-245">
            de los usuarios reporta una respuesta en menos de un día.
          </h2>
          <p className="text-xl text-gray-400 leading-relaxed max-w-3xl mx-auto" data-id="element-246">
            Lo que cambia en las primeras 24 horas no es necesariamente que
            vuelvas a casarte, sino la{' '}
            <strong className="text-white" data-id="element-247">dinámica de poder</strong>. Al enviar
            el primer mensaje del Protocolo, es imposible de ignorar
            psicológicamente.
          </p>
        </FadeIn>
      </div>
    </section>;
}